import { Link } from "react-router-dom";
import { Linkedin, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { BUSINESS } from "../data/site";

const cols = [
  { title: "Services", links: [
    ["Clinical Documentation", "/services/clinical-documentation"],
    ["Medical Transcription", "/services/medical-transcription"],
    ["Editing & QA", "/services/editing-quality-assurance"],
    ["AI-Assisted Editing", "/services/ai-content-humanisation"],
    ["Billing & Coding Support", "/services/medical-billing-coding"],
  ]},
  { title: "Explore", links: [
    ["About", "/about"],
    ["Industries", "/industries"],
    ["Quality & Process", "/quality-process"],
    ["Insights", "/insights"],
    ["Contact", "/contact"],
  ]},
  { title: "Legal", links: [
    ["Privacy Policy", "/privacy-policy"],
    ["Terms of Use", "/terms"],
    ["Data Handling Notice", "/data-handling"],
  ]},
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-brand-evergreen text-white/80" data-testid="site-footer">
      <div className="container-page grid gap-12 py-16 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo tone="white" showDescriptor />
          <p className="mt-4 max-w-xs text-[14px] leading-relaxed text-white/60">
            Accuracy Beyond Words. A human-led documentation, quality assurance and business-support partner.
          </p>
          <p className="mt-5 flex items-center gap-2 text-[14px] text-white/70"><MapPin className="h-4 w-4 text-brand-gold" /> {BUSINESS.city}</p>
          <a href={BUSINESS.linkedinProfile} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/70 transition-colors hover:border-brand-gold hover:text-white" aria-label="LinkedIn">
            <Linkedin className="h-4 w-4" />
          </a>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <p className="mb-4 font-heading text-[13px] font-700 uppercase tracking-wider text-white">{c.title}</p>
            <ul className="space-y-2.5">
              {c.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="text-[14px] text-white/60 transition-colors hover:text-brand-gold">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="container-page flex flex-col items-center justify-between gap-2 py-5 text-[12.5px] text-white/50 sm:flex-row">
          <span>© {new Date().getFullYear()} Primevanta Global. All rights reserved.</span>
          <span>New Delhi, India · Remote delivery worldwide</span>
        </div>
      </div>
    </footer>
  );
}
